// extracted by mini-css-extract-plugin
export default {"layout":"SignedInLayout_layout__hDeRz"};